function User ( email, name, orgId ){

  this.email = email;
  this.name = name;
  this.orgId = orgId;

}

User.prototype.removeFromCompany = function () {

  return new Promise( function( resolve, reject ){
    let postObject = {
      source: 'remove-user-from-organisation',
      email: this.email
    }

    fetch('/form-submission-handler/',
    {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'data': postObject
      })
    }).then( response => {
      if( !response.ok ){
        console.log(response);
        return Promise.reject(new Error(response.statusText))
      } else {
        return Promise.resolve(response)
      }
    }).then( response => {
      resolve( response );
    })
    .catch( err => {
      reject( err );
    })
  }.bind(this))
};

User.prototype.addToCompany = function () {
  return new Promise( function( resolve, reject ){
    let postObject = {
      source: 'add-user-to-organisation',
      email: this.email,
      name: this.name,
      orgid: this.orgId
    }

    console.log(postObject);
    console.log(JSON.stringify({ 'data': postObject }))

    fetch('/form-submission-handler/',
    {
      method: 'POST',
      mode: 'same-origin',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'data': postObject
      })
    }).then( response => {
      if( !response.ok ){
        return Promise.reject(new Error(response.statusText))
      } else {
        return Promise.resolve(response)
      }
    }).then( response => {
      resolve( response );
    })
    .catch( err => {
      reject( err );
    })
  }.bind(this))
};

export default User;
